module.exports = __webpack_public_path__ + "img/8c430f0847ca48139f44171f240e656d.png";